import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 3rem 1rem 4rem;

  @media (max-width: 768px) {
    padding: 2rem 0.5rem 3rem;
  }
`;

export const PolicyArticle = styled.article`
  max-width: 860px;
  margin: 0 auto;
  color: ${({ theme }) => theme.colors.blue11};
`;

export const Header = styled.header`
  padding-bottom: 2rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.blue3};
`;

export const Eyebrow = styled.p`
  margin: 0 0 0.75rem;
  color: ${({ theme }) => theme.colors.blue9};
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const Title = styled.h1`
  margin: 0 0 1rem;
  color: ${({ theme }) => theme.colors.blue9};
  font-size: 2.6rem;
  line-height: 1.12;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.65rem;
  }
`;

export const EffectiveDate = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.blue11};
  font-size: 0.98rem;
`;

export const Section = styled.section`
  margin-bottom: 2rem;

  p {
    margin: 0 0 1rem;
    font-size: 1rem;
    line-height: 1.75;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (max-width: 480px) {
    margin-bottom: 1.5rem;

    p {
      font-size: 0.92rem;
      line-height: 1.65;
    }
  }
`;

export const SectionTitle = styled.h2`
  margin: 0 0 0.85rem;
  color: ${({ theme }) => theme.colors.blue9};
  font-size: 1.25rem;
  line-height: 1.3;
`;

export const List = styled.ul`
  margin: 0 0 1rem;
  padding-left: 1.4rem;

  li {
    margin-bottom: 0.55rem;
    line-height: 1.6;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (max-width: 480px) {
    padding-left: 1.15rem;

    li {
      font-size: 0.92rem;
    }
  }
`;

export const ContactBlock = styled.address`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-style: normal;

  strong {
    color: ${({ theme }) => theme.colors.blue9};
  }

  a {
    color: ${({ theme }) => theme.colors.blue9};
    overflow-wrap: anywhere;
  }
`;
